export default "__VITE_ASSET__9ed5bd3f__"